{
    "alerts": {
        "AN_ERROR_OCCURRED": "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
        "ANCHOR_TAB_STRING_NOT_FOUND": "Jeder Unterzeichner muss mindestens ein Dokument unterschreiben.",
        "DUPLICATE_SIGNER_ERROR": "Doppelte Unterzeichner müssen dieselbe Unterzeichneroption haben.",
        "DUPLICATE_EMAIL_MOBILE_SIGNER_ERROR": "Die E-Mail-Adressen und Telefonnummern der Teilnehmer müssen individuell sein und dürfen nicht miteinander übereinstimmen",
        "EMAIL_AND_PHONE_MANDATORY": "Email und Mobilnummer sind für alle Unterzeichner erforderlich",
        "EXCLUDE_ALFA_CASE_STATUS_ERROR_MESSAGE": "Für dieses Angebot kann kein Umschlag erstellt werden, da das Angebot noch nicht in Finance Connect eingereicht wurde",
        "GENERIC_ERROR": "Die Umschlagerstellung ist aufgrund eines unbekannten Fehlers fehlgeschlagen.",
        "GUARANTOR_WARNING_MESSAGE": "Projekte mit Bürgschaften sind nicht autorisiert für E-sign",
        "INVALID_EMAIL_ADDRESS_FOR_RECIPIENT": "Ungültige E-Mail-Adresse für Unterzeichner angegeben.",
        "MANDATORY_FIELD_FOR_SIGNER_ERROR": "Email und Mobilnummer sind für alle Unterzeichner erforderlich",
        "NO_ACCESS_TO_PROPOSAL_TRACKING_OR_ESIGN": "Sie haben keinen Zugriff auf die Module Proposal Tracking oder eSignature.",
        "NO_DOCUMENT_SELECTED": "Bitte wählen Sie mindestens ein Dokument aus.",
        "NO_ENVELOPE_FOUND": "Für das Angebot wurde kein Umschlag gefunden.",
        "NO_MODULE_ASSIGNED": "Kein Modul zugeordnet",
        "NO_PROPOSALS_AVAILABLE_FOR_GIVEN_SEARCH_CRITERIA": "Keine Vorschläge für die angegebenen Suchkriterien verfügbar.",
        "NO_PROPOSALS_AVAILABLE_FOR_GIVEN_SEARCH_CRITERIA_CLICK_CLEAR": "Keine Vorschläge für die angegebenen Suchkriterien verfügbar. Klicken Sie auf die Schaltfläche zurücksetzen, um alle Datensätze anzuzeigen.",
        "NO_RESULTS_FOUND": "Keine Ergebnisse gefunden",
        "NO_SIGNED_DOCUMENTS_AVAILABLE": "Für diesen Umschlag sind keine Dokumente verfügbar.",
        "NO_SIGNER_DOCUMENT_SELECTED_ACTION": "Bitte wählen Sie mindestens ein Dokument und einen Unterzeichner aus, um einen Umschlag zu erstellen.",
        "NO_SIGNER_OR_DOCUMENT_SELECTED": "Kein Unterzeichner/Dokument ausgewählt",
        "NO_SIGNER_SELECTED": "Bitte wählen Sie mindestens einen Unterzeichner aus.",
        "SEARCH_FOR_A_PROPOSAL_TO_CONTINUE": "Suchen Sie nach einem Angebot, um fortzufahren.",
        "START_DATE_WARNING_MESSAGE": "Das Startdatum des Angebots liegt vor dem Datum der Unterzeichnung. Bitte überprüfen Sie die Daten und stellen Sie sicher, dass die Unterzeichnung vor oder am selben Datum wie das Startdatum des Angebots liegt.",
        "INVALID_PRODUCT_WARNING": "Esign is not available for Leasing and Renting Product"
    },
    "docusignErrorMessages": {
        "ANCHOR_TAB_STRING_NOT_FOUND": "Der ausgewählte Unterzeichner ist nicht berechtigt das ausgewählte Dokument zu unterschreiben",
        "INVALID_EMAIL_ADDRESS": "Ungültige E-Mail-Adresse",
        "INVALID_EMAIL_ADDRESS_FOR_RECIPIENT": "Die E-Mail-Adresse des Empfängers ist ungültig.",
        "PHONE_NUMBER_INVALID": "Telefonnummer ist ungültig."
    },
    "labels": {
        "ACTION": "Aktion",
        "ADD": "Hinzufügen",
        "ADD_NEW_SIGNER": "Unterzeichner hinzufügen",
        "ADD_NEXT": "Weitere hinzufügen",
        "ADD_SIGNER": "Zusätzlicher Unterzeichner",
        "ADMIN_UTILITY": "Admin Utility",
        "APPROVED": "Genehmigt",
        "APPROVED_WITH_CONDITIONS": "Genehmigt mit Auflage",
        "ASSOCIATE": "Unterzeichner",
        "ASSOCIATED_PARTIES": "Unterzeichner",
        "AUTO_APPROVED": "Automatische Genehmigung",
        "AWAITING_FURTHER_INFORMATION_DOCUMENTS": "Zusätzlich Dokumente angefordert",
        "BACK_TO_DASHBOARD": "Zurück zur Übersicht",
        "BULK_EREGISTRY_UTILITY": "Massendienstprogramm E-Registry",
        "BUNDLE": "Projektnummer",
        "CLEAR": "zurücksetzen",
        "CO-BORROWER": "Weiterer Darlehensnehmer",
        "COMBINED": "Kombiniert",
        "COMPLETED": "Beendet",
        "CONTRACT_PAID_OFF": "Ausgezahlt",
        "COUNTRY": "Land",
        "CREATE_ENVELOPE": "Umschlag erstellen",
        "CREATED": "Erstellt",
        "CREATED_DATE": "Datum der Erstellung",
        "CREDIT_DECISION_ROUTED_FOR_MANUAL_REVIEW": "In Bearbeitung",
        "DEALER": "Vertriebspartner",
        "DEALER_REFERENCE": "Vertriebspartnerreferenz",
        "DEALERSHIP_NAME": "Vertriebspartner",
        "DECLINED": "Abgelehnt",
        "DECLINED_DATE": "Datum der Ablehnung",
        "DECLINED_REASON": "Grund der Ablehnung",
        "DELETED": "Gelöscht",
        "DELIVERED": "Geliefert",
        "DOCUMENT_NAME": "Dokumentenname",
        "DOCUMENTS": "Dokumente",
        "DOCUMENTS_SELECTED": "ausgewählte Dokumente",
        "DOWNLOAD": "Herunterladen",
        "E_SIGNATURE": "E-Signature",
        "E_SIGNATURE_DASHBOARD": "E-Signature Übersicht",
        "EMAIL": "Email",
        "ENVELOPE_ID": "Umschlag ID",
        "ENVELOPE_REVIEW": "Umschlag prüfen",
        "E-REGISTRY_DOWNLOAD": "E-Registrierung",
        "EXAMPLE_PHONE_NUMBER": "Bsp. +49 123456789",
        "EXPIRED": "Abgelaufene Genehmigung",
        "FETCHING_DOCUMENTS_FOR": "Abrufen von Dokumenten für",
        "GERMANY": "Deutschland",
        "GET_STATUS": "Status aktualisieren",
        "GUARANTOR": "Bürge",
        "HI": "Hi",
        "ICS_REFERENCE": "ICS ID",
        "ISD_CODE_IS_REQUIRED": "ISD-Code ist erforderlich",
        "JDF_SIGNER": "JDF-Unterzeichner",
        "MATURITY_DATE": "Fälligkeitstag",
        "MERGER_AND_ACQUISITION": "Fusionen und Übernahmen",
        "MOBILE": "Mobilfunk-Nr.",
        "NAME": "Name",
        "NO_DECLINING_REASON_PROVIDED": "Kein Ablehnungsgrund angegeben",
        "NOT_AVAILABLE": "Nicht verfügbar",
        "NOT_SIGNED": "Nicht unterschrieben",
        "NOT_VIEWED": "Nicht angesehen",
        "OF": "von",
        "ON_DEMAND": "Weiterer Unterzeichner",
        "OPTION": "Option",
        "OPTIONS": "Optionen",
        "ORDER": "Reihenfolge",
        "PRIMARY": "Kunde",
        "PRIMARY_CUSTOMER": "Kunde",
        "PROCESSING": "In Bearbeitung",
        "PRODUCT": "Produkt",
        "PROPOSAL": "Angebotsnummer",
        "PROPOSAL_DETAILS": "Angebotsdetails",
        "PROPOSAL_TRACKING": "Angebotsverfolgung",
        "PROPOSED": "Vorgeschlagen",
        "QUOTE": "Angebotsnummer",
        "QUOTE_STATUS": "Angebotsstatus",
        "REVIEW_MESSAGE_DETAILS_CANNOT_UPDATE": "c. Diese Details können nicht aktualisiert werden, nachdem der Umschlag gesendet wurde.",
        "REVIEW_MESSAGE_ISD_CODE": "b. Der Mobilfunk-Nr. muss für alle Unterzeichner der Ländercode (ISD-Code) vorangestellt werden. Beispiel: +49 123456789",
        "REVIEW_MESSAGE_OTP": "a. Jeder Unterzeichner wird über ein einmaliges Passwort authentifiziert, das an die unten angegebene Mobilfunk-Nr. gesendet wird.",
        "ROLE": "Rolle",
        "SALESPERSON": "Verkaufsberater",
        "SAVE_&_ADD_NEXT_SIGNER": "Speichern und nächsten Unterzeichner hinzufügen",
        "SAVE_SIGNER": "Unterzeichner speichern",
        "SEARCH": "Suche",
        "SELECT_DOCUMENTS": "Auswahl Dokumente",
        "SELECTED_DOCUMENTS": "versendete Dokumente",
        "SEND_ENVELOPE": "Umschlag versenden",
        "SENDING_ENVELOPE": "Umschlag wird versendet",
        "SENT": "Versendet",
        "SENT_/_VIEWED": "Versendet",
        "SENT_DATE": "Versanddatum",
        "SEPARATE": "Getrennt",
        "SIGN_BY_EMAIL": "Sign by Email",
        "SIGN_NOW": "Sign Now",
        "SIGNED": "Unterzeichnet",
        "SIGNED_DATE": "Unterschriftsdatum",
        "SIGNER": "Unterzeichner",
        "SIGNERS": "Unterzeichner",
        "SIGNING_OPTION": "Optionen",
        "SIGNING_ORDER": "Reihenfolge der Unterzeichner",
        "SIGNING_ORDER_PREVIEW": "Reihenfolge der Unterzeichner",
        "SIGNING_STATUS": "Umschlag Status",
        "PORTUGAL": "Portugal",
        "SPAIN": "Spanien",
        "START_DATE": "Startdatum",
        "STATUS": "Status",
        "STATUS_DATE": "Status Datum",
        "SUBMITTED": "Eingereicht",
        "TEMPLATE": "Vorlage",
        "UNDELIVERABLE": "Nicht zustellbar",
        "UNITED_KINGDOM": "Vereinigtes Königreich",
        "UPDATING_STATUS": "Status aktualisieren",
        "VIEWED": "Angesehen",
        "VIEWED_DATE": "Bearbeitungsdatum",
        "VOIDED": "Annulliert",
        "WITHDRAWN": "Zurückgezogen",
        "PRIMARY_QUOTE": "eingereichte Kalkulation",
        "ENVELOPE_SENT_UNDER_PROCESS": "Umschlag wird versendet. Bitte warten Sie",
        "ENVELOPE_SUCCESSFULLY_SENT": "Ihr Umschlag wurde erfolgreich versendet"
    },
    "messages": {
        "BUNDLE_NUMBER_NOT_FOUND": "Kein Ergebnis gefunden. Keine Angebote für die Projekt-Nr. gefunden.",
        "CREATE_ON_DEMAND_SIGNER_FOR_ASSOCIATE": "Bitte fügen Sie einen weiteren Unterzeichner hinzu",
        "DOCUMENT_DOWNLOAD_FAILED": "Herunterladen der Dokumente fehlgeschlagen",
        "ICS_NUMBER_NOT_FOUND": "Kein Ergebnis gefunden. Kein Angebot für die ICS-Nr. gefunden.",
        "INVALID_BUNDLE_NUMBER": "Die Projekt-Nr. ist ungültig. Bitte verwenden Sie eine gültige Nummer. ",
        "INVALID_ICS_NUMBER": "Die ICS Nummer ist ungültig. Bitte verwenden Sie ein gültige Nummer.",
        "INVALID_PRIMARY_CUSTOMER": "Der Kundenname ist ungültig. Bitte verwenden Sie einen gültigen Namen.",
        "INVALID_QUOTE_NUMBER": "Die Angebots-Nr. ist ungültig. Bitte verwenden Sie eine gültige Nummer.",
        "PRIMARY_CUSTOMER_NOT_FOUND": "Kein Ergebnis gefunden. Bitte überprüfen Sie Ihre Eingabe.",
        "QUOTE_NUMBER_NOT_FOUND": "Kein Ergebnis gefunden. Die Angebots-Nr. stimmt nicht mit der Projekt-Nr. überein. "
    },
    "products": {
        "DPFR_24_MONTH_LOAN_STOCK_DE": "VP - Lager (24 Monate)",
        "DPFR_LOAN_DE": "VP - Try&Buy/Mietpark",
        "DPFR_LOAN_STOCK_DE": "VP - Lager",
        "DPFR_NON_FULL_PAYOUT_LEASE_DE": "VP - Leasing Teilamortisation",
        "DPFR_OPERATING_LEASE_DE": "VP - Operate Leasing",
        "LOAN_DE": "Darlehen",
        "NON_FULL_PAYOUT_LEASE_DE": "Leasing Teilamortisation",
        "OPERATING_LEASE_DE": "Operate Leasing"
    }
}
